<template>
    <thead class="combinations-table-header">
        <tr class="combinations-table-header-row">
          <th class="combinations-table-header-row-cell" scope="col">
          </th>
            <th class="combinations-table-header-row-cell" style="width: 40%;" scope="col">
                <span>{{ i18n("views.Combinations.Tables") }}</span>&nbsp;<span class="mandatory">*</span>
            </th>
            <th class="combinations-table-header-row-cell" scope="col">
                <span>{{ i18n("views.Combinations.PreferredMinimumOccupancy") }}</span>&nbsp;<span class="mandatory">*</span>
            </th>
            <th class="combinations-table-header-row-cell" scope="col">
                <span>{{ i18n("views.Combinations.MaximumOccupancy") }}</span>&nbsp;<span class="mandatory">*</span>
            </th>
            <th class="combinations-table-header-row-cell" scope="col">
                <span>{{ i18n("views.Combinations.SortOrder") }} </span>
            </th>
            <th class="combinations-table-header-row-cell" scope="col"></th>
        </tr>
    </thead>
</template>

<script setup lang="ts">
    import { i18n } from "@/portal/Trans";
</script>

<style scoped lang="scss">
    .combinations-table-header {
        .combinations-table-header-row {
            
            .combinations-table-header-row-cell {
                padding: 7.5px;
                
                .mandatory {
                    display: inline-block;
                    vertical-align: top;
                    font-size: 12px;
                    color: #fd397a;
                }
                
                span {
                    font-weight: 500;
                    color: #595d6e;
                }
            }
        }
    }
</style>
